import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice";
import correspondenceReduce from "./slices/correspondenceSlice";
import expedientReduce from "./slices/expedientSlice";
import processReduce from "./slices/processSlice";
import contractReducer from "./slices/contractSlice";
import pqrsdReducer from "./slices/pqrsdSlice";
import applicantReducer from "./slices/applicantSlice";
import agreementReducer from "./slices/agreementSlice";
import entityReducer from "./slices/entitySlice";

const appReducer = combineReducers({
  user: userReducer,
  correspondences: correspondenceReduce,
  expedient: expedientReduce,
  process: processReduce,
  contracts: contractReducer,
  pqrsd: pqrsdReducer,
  applicant: applicantReducer,
  agreement: agreementReducer,
  entity: entityReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "user/logout") {
    state = undefined;
  }
  return appReducer(state, action);
};

export default configureStore({
  reducer: rootReducer,
});
